<div  class="aip-topol-desc-margin aip-theme-bg-alt">
    <div *ngIf="showLastAccounts" class="top-accounts-container aip-theme-bg">
        <div class="top-accounts-header">Recently Visited</div>
        <div class="topAccounts">
            <div class="previous-button" [class]="{ 'disable-button': disablePrevious }" (click)="getPrevAccounts()">
                <mat-icon svgIcon="previous-icon" aria-hidden="false" style="height: 60px; width: 60px;"></mat-icon>
            </div>
            <div class="last-accounts-container">
                <ul>
                    <li *ngFor="let itm of lastAccounts" class="icon-container" [matTooltip]="itm.name" matTooltipClass="capitalize-tooltip" (click)="redirect(itm)">
                        <img *ngIf="itm.logofile; else nameTemplate" class="image-fit" [src]="'/logos/' + itm.logofile">
                        <ng-template #nameTemplate>
                            <span class="account-name">{{ getName(itm) }}</span>
                        </ng-template>
                    </li>
                    <li *ngFor="let itm of accountPlaceHolders"></li>
                </ul>
            </div>
            <div class="next-button" [class]="{ 'disable-button': disableNext }" (click)="getNextAccounts()">
                <mat-icon svgIcon="next-icon" aria-hidden="false" style="height: 60px; width: 60px;"></mat-icon>
            </div>
        </div>
    </div>
    <mat-divider class="aip-view-divider"></mat-divider>
    <div class="filterAccounts">
        <div class="header">
            {{ fromEstateMap ? 'Account Filtering' : (!isLoading ? (pageLength + ' accounts found') : '') }}
        </div>
        <div class="aip-woptions-sidebar">
            <ng-container *ngFor="let rowItems of filters">
                <div class="aip-row">
                    <ng-container *ngFor="let filter of rowItems">
                        <div class="api-col">
                            <label>{{ filter.title }}</label>
                        </div>
                        <div class="api-col">
                            <app-multi-selection *ngIf="filter.type === 'select'"
                                appendTo="#selectOverlayDiv"
                                [items]="this[filter.listName]"
                                [bindValue]="filter.bindValue"
                                [bindLabel]="filter.bindLabel"
                                [fieldName]="filter.fieldName"
                                [selectedValues]="this.data[filter.fieldName]"
                                [selectedOptionWidth]="90"
                                [groupBy]="filter.groupBy"
                                [selectableGroup]="filter.selectableGroup"
                                [selectableGroupAsModel]="filter.selectableGroupAsModel"
                                [disabled]="filter.disabled()"
                                (change)="filter.change($event)"
                            ></app-multi-selection>
                            <input *ngIf="filter.type === 'input'" matInput type="text" class="aip-input custom-input" [(ngModel)]="data[filter.fieldName]">
                        </div>
                    </ng-container>
                    <ng-container *ngIf="rowItems.length === 1">
                        <div class="api-col"></div>
                        <div class="api-col"></div>
                    </ng-container>
                </div>
            </ng-container>
            <div class="aip-row search-button-row">
                <div>
                    <ng-container *ngIf="currentFilterList.length > 0 && fromEstateMap">
                        <button id="triggerFilterOverlayButton" mat-raised-button color="primary" class="aip-button custom-button" (click)="toggleOverlay()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">Filters</button>
                        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen">
                            <div id="filterOverlay" class="filter-fields-dropdown">
                                <label id="filter-field-group-label">Select Filters</label>
                                <div class="filter-field-group">
                                    <ng-container *ngFor="let filterField of currentFilterList" class="filter-field-radio-button">
                                        <mat-checkbox [(ngModel)]="filterField.checked" color="primary" [name]="filterField.name" [value]="filterField.value" [disabled]="filterField.disable" class="filter-field-checkbox" (change)="updateSelectedFilters($event)">
                                            {{ filterField.name }}
                                        </mat-checkbox>
                                    </ng-container>
                                </div>
                                <div>
                                    <button mat-raised-button [color]="disableSetFilterButton() ? '' : 'primary'" class="aip-button custom-button" [disabled]="disableSetFilterButton()" (click)="setFilter()">Apply</button>
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                    <button *ngIf="showSubmitButton()" mat-raised-button color="primary" class="aip-button custom-button" (click)="filterAccounts()">Submit</button>
                    <button *ngIf="hasFilter || !fromEstateMap" mat-raised-button color="primary" class="aip-button custom-button" (click)="reset()">{{ fromEstateMap ? 'Reset' : 'Clear Filters' }}</button>
                </div>
                <div>
                    <span *ngIf="!isLoading && hasFilter" class="search-result-text">{{ pageLength + ' accounts found' }}</span>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="this.isLoading">
        <mat-spinner diameter=50 class="aip-topol-spinner"></mat-spinner>
    </ng-container>
    <div class="content">
        <mat-card class="aip-widget-fullscreen mat-elevation-z4">
            <app-table-grid-async class="table" [tableDef]="entitiesTableDef" [data]="accountResults" [isTotalData]="true" scrollTopElementClass="stage" [filterOn]="entitiesTableDef.filterOn" [loading]="loading" (reload)="filterAccounts()"></app-table-grid-async>
        </mat-card>
    </div>
</div>
<!-- Overlay for the dropdowns -->
<div id="selectOverlayDiv" #selectOverlay class="aip-select-overlay" style="position: absolute;"></div>
